import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Permissions_RLP extends PureComponent {
  render() {
    return (
      <div className="row" id="permissions_rlp">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Level Permissions</h2>
              <p>
                Recordable permissions also referred to as rlp allow the
                administrator to divide records within a particular object to
                different user groups. Record level permissions work by an array
                of RLP strings stored in the record. this gives you the ability
                to have more than one RLP connected to a record.
              </p>
              <p>
                New RLPs can be added through the settings section of the Nexoid
                application. RLPs Can be automatically installed as part of
                prebuilt modules.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Level Permission Examples</h2>
            </section>
            <section>
              <h3>Example 1</h3>
              <p>
                This will give a user the ability to read all its{" "}
                <strong>incident</strong> records but only the ability to edit{" "}
                <strong>ICT</strong> <strong>incident</strong> records.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <div className="darkCode">
                  <div>[</div>
                  <div className="i1">
                    <span className="jsonY">"incident|*|Read"</span>,
                  </div>
                  <div className="i1">
                    <span className="jsonY">"incident|ICT|Edit"</span>
                  </div>
                  <div>]</div>
                </div>
              </div>
            </section>
            <section>
              <h3>Example 2</h3>
              <p>
                This example gives the user the ability to view all{" "}
                <strong>client</strong> records that do not have a record level
                permission value and the <strong>client</strong> records that
                have a <strong>FACILITIES</strong> record level permission
                value.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <div className="darkCode">
                  <div>[</div>
                  <div className="i1">
                    <span className="jsonY">"client|?|Read"</span>,
                  </div>
                  <div className="i1">
                    <span className="jsonY">"client|FACILITIES|Read"</span>
                  </div>
                  <div>]</div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Permissions_RLP;



// WEBPACK FOOTER //
// ./src/components/knowlege/security/Permissions_RLP.js